// table 中 mark 關鍵字的顏色設定

export const MARK_STYLE = {
  primary: {
    css: "background-color: #F8EA8C;",
    name: "primary", // key 與 name 必須相同
    hex: "#fce262",
    key: "primary",
    label: "primary", // label 為要顯示的名稱
    value: "primary", // value 與 name 必須相同
  },
  secondary: {
    css: "background-color: #A0E7E5;",
    name: "secondary",
    hex: "#459bff",
    key: "secondary",
    label: "secondary",
    value: "secondary",
  },
  success: {
    css: "background-color: #B4F8C8;",
    name: "success",
    hex: "#b3e364",
    key: "success",
    label: "success",
    value: "success",
  },
  info: {
    css: "background-color: #FFA384;",
    name: "info",
    hex: "#ffb629",
    key: "info",
    label: "info",
    value: "info",
  },
  warning: {
    css: "background-color: #FA26A0;",
    name: "warning",
    hex: "#ff7ce1",
    key: "warning",
    label: "warning",
    value: "warning",
  },
};

export const FONT_SIZE = {
  mini: {
    fontSize: "0.875rem",
    name: "mini", // key 與 name 必須相同
    key: "mini",
    label: "mini", // label 為要顯示的名稱
    value: "mini", // value 與 name 必須相同
  },
  small: {
    fontSize: "1.0rem",
    name: "small",
    key: "small",
    label: "small",
    value: "small",
  },
  normal: {
    fontSize: "1.2rem",
    name: "normal",
    key: "normal",
    label: "normal",
    value: "normal",
  },
  large: {
    fontSize: "1.4rem",
    name: "large",
    key: "large",
    label: "large",
    value: "large",
  },
};
